/**
 * Coups de pouce — attendu 626 (appliquer une fraction à un entier).
 *
 * Routage par generator_key (les 13 keys de format complètes).
 * Exemple HORS pool : [35, 2, 5] absent de POOL_A.
 */

// La verbalisation officielle rendue VISUELLE (retour user) : la barre
// de 35 coupée en 5 parts de 7, on en prend 2 → 14. Un seul objet qui
// se transforme — « divise d’abord, multiplie ensuite ».
const SVG_DE = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 160" width="290" height="155" role="img" data-etapes="4"
     aria-label="On cherche 2 cinquièmes de 35. Une barre de longueur 35 est coupée en 5 parts égales : chaque part vaut 35 divisé par 5, soit 7. On prend 2 parts : 2 fois 7 égale 14. On divise d’abord, on multiplie ensuite">
  <style>
    .anim { opacity: 1; }
    [data-caption] { opacity: 0; }
    [data-caption="4"] { opacity: 1; }
    @media (prefers-reduced-motion: no-preference) {
      .d1 { opacity: 0; animation: cp626de 8s linear infinite 0s; }
      .c1 { opacity: 0; animation: cp626dec 8s linear infinite 0s; }
      .d2 { opacity: 0; animation: cp626de 8s linear infinite 2s; }
      .c2 { opacity: 0; animation: cp626dec 8s linear infinite 2s; }
      .d3 { opacity: 0; animation: cp626de 8s linear infinite 4s; }
      .c3 { opacity: 0; animation: cp626dec 8s linear infinite 4s; }
      .d4 { opacity: 0; animation: cp626de 8s linear infinite 6s; }
      .c4 { opacity: 0; animation: cp626decf 8s linear infinite 6s; }
    }
    @keyframes cp626de { 0%, 2% { opacity: 0; } 6%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
    @keyframes cp626dec { 0%, 2% { opacity: 0; } 5%, 22% { opacity: 1; } 26%, 100% { opacity: 0; } }
    @keyframes cp626decf { 0%, 2% { opacity: 0; } 5%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
  </style>
  <g class="anim d1" data-etape="1">
    <rect x="30.0" y="45.0" width="240.0" height="30.0" fill="#fed7aa" fill-opacity="0.35" stroke="#f97316" stroke-width="2"/>
    <text x="150" y="24" text-anchor="middle" font-size="12" font-weight="bold" fill="#334155">35</text>
    <line x1="34.0" y1="32.0" x2="266.0" y2="32.0" stroke="#334155" stroke-width="1.2"/><polygon points="31.0,32.0 37.0,29.0 37.0,35.0" fill="#334155"/><polygon points="269.0,32.0 263.0,29.0 263.0,35.0" fill="#334155"/>
  </g>
  <g class="anim d2" data-etape="2">
    <line x1="78.0" y1="45.0" x2="78.0" y2="75.0" stroke="#dc2626" stroke-width="1.5" stroke-dasharray="3 2"/>
    <line x1="126.0" y1="45.0" x2="126.0" y2="75.0" stroke="#dc2626" stroke-width="1.5" stroke-dasharray="3 2"/>
    <line x1="174.0" y1="45.0" x2="174.0" y2="75.0" stroke="#dc2626" stroke-width="1.5" stroke-dasharray="3 2"/>
    <line x1="222.0" y1="45.0" x2="222.0" y2="75.0" stroke="#dc2626" stroke-width="1.5" stroke-dasharray="3 2"/>
  </g>
  <g class="anim d3" data-etape="3">
    <text x="54.0" y="65.0" text-anchor="middle" font-size="13" font-weight="bold" fill="#b45309">7</text>
    <text x="102.0" y="65.0" text-anchor="middle" font-size="13" font-weight="bold" fill="#b45309">7</text>
    <text x="150.0" y="65.0" text-anchor="middle" font-size="13" font-weight="bold" fill="#b45309">7</text>
    <text x="198.0" y="65.0" text-anchor="middle" font-size="13" font-weight="bold" fill="#b45309">7</text>
    <text x="246.0" y="65.0" text-anchor="middle" font-size="13" font-weight="bold" fill="#b45309">7</text>
    <text x="150" y="98" text-anchor="middle" font-size="12" fill="#334155">35 ÷ 5 = <tspan font-weight="bold" fill="#b45309">7</tspan></text>
  </g>
  <g class="anim d4" data-etape="4">
    <rect x="30.0" y="45.0" width="96.0" height="30.0" fill="#f97316" fill-opacity="0.45"/>
    <line x1="34.0" y1="118.0" x2="122.0" y2="118.0" stroke="#f97316" stroke-width="1.2"/><polygon points="31.0,118.0 37.0,115.0 37.0,121.0" fill="#f97316"/><polygon points="125.0,118.0 119.0,115.0 119.0,121.0" fill="#f97316"/>
    <text x="78.0" y="132" text-anchor="middle" font-size="13" font-weight="bold" fill="#f97316">2 × 7 = 14</text>
  </g>
  <g class="anim c1" data-caption="1">
    <text x="128" y="152" text-anchor="end" font-size="11.5" fill="#334155">on cherche</text>
    <text x="142.0" y="140.0" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#f97316">2</text><line x1="135.5" y1="143.5" x2="148.5" y2="143.5" stroke="#f97316" stroke-width="1.1"/><text x="142.0" y="152.5" text-anchor="middle" font-size="9.5" font-weight="bold" fill="#f97316">5</text>
    <text x="154" y="152" font-size="11.5" fill="#334155">de <tspan font-weight="bold">35</tspan></text>
  </g>
  <g class="anim c2" data-caption="2">
    <text x="150" y="152" text-anchor="middle" font-size="11.5" fill="#334155">coupe 35 en <tspan font-weight="bold" fill="#dc2626">5 parts égales</tspan> : des cinquièmes</text>
  </g>
  <g class="anim c3" data-caption="3">
    <text x="150" y="152" text-anchor="middle" font-size="11.5" fill="#334155"><tspan font-weight="bold" fill="#b45309">divise d’abord</tspan> : chaque part vaut <tspan font-weight="bold" fill="#b45309">7</tspan></text>
  </g>
  <g class="anim c4" data-caption="4">
    <text x="150" y="152" text-anchor="middle" font-size="11.5" fill="#334155"><tspan font-weight="bold" fill="#f97316">multiplie ensuite</tspan> : prends 2 parts, 2 × 7 = <tspan font-weight="bold" fill="#f97316">14</tspan> !</text>
  </g>
</svg>`.trim();

const FICHE_DE = {
    pages: [
        {
            titre: 'Divise d\'abord, multiplie ensuite',
            lignes: [
                '**Prends ton brouillon** et pose les calculs.',
                '**2 cinquièmes** de 35, c\'est **2 fois un cinquième** de 35 : **divise d\'abord** par 5, **multiplie ensuite** par 2.',
                'Sur ton cahier : $\\dfrac{2}{5} \\times 35 = 2 \\times \\dfrac{35}{5} = 2 \\times 7 = 14$.',
            ],
            svg: SVG_DE,
        },
    ],
};

// Variante heures de la chaîne « divise d'abord » : le rappel
// « 1 h = 60 min » en point 2 (demande user). Exemple hors pool :
// [3, 20] absent de POOL_C.
const FICHE_HEURES_MIN = {
    pages: [
        {
            titre: 'Une heure, c\'est 60 minutes',
            lignes: [
                '**Prends ton brouillon** et pose les calculs.',
                '**Une heure, c\'est 60 minutes.**',
                '**3 vingtièmes** d\'heure, c\'est **3 fois un vingtième** de 60 min : **divise d\'abord** (60 ÷ 20 = 3), **multiplie ensuite** (3 × 3 = **9 min**).',
            ],
        },
    ],
};

// Famille B : la division ne tombe pas juste → multiplier le numérateur.
// Exemple hors pool : [7, 2, 5] absent de POOL_B — écho de FICHE_DE
// (2/5 de 35 tombait juste, 2/5 de 7 non).
const FICHE_FRACTIONNAIRE = {
    pages: [
        {
            titre: 'Quand ça ne tombe pas juste',
            lignes: [
                '**Prends ton brouillon.**',
                'Quand la division **ne tombe pas juste** (7 n\'est pas divisible par 5), multiplie le numérateur.',
                'Sur ton cahier : $\\dfrac{2}{5} \\times 7 = \\dfrac{2 \\times 7}{5} = \\dfrac{14}{5}$.',
                'Vérifie que ta fraction ne se **simplifie plus** : $\\dfrac{14}{5}$ est irréductible.',
            ],
        },
    ],
};

// Heures impropres, animé (retour user) : 60 ÷ 4 = 15 EXPLICITE →
// 9 × 15 = 135 → la barre des paquets de 60 (60|60|15) → 2 h 15.
// Exemple hors pool : [9, 4] absent de POOL_C2.
const SVG_HEURES_HM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 190" width="290" height="184" role="img" data-etapes="4"
     aria-label="9 quarts d’heure. Une heure, c’est 60 minutes : un quart d’heure, c’est 60 divisé par 4, soit 15 minutes. 9 fois 15 égale 135 minutes. On découpe 135 en paquets de 60 : deux paquets de 60, et il reste 15. Donc 9 quarts d’heure, c’est 2 heures 15 minutes">
  <style>
    .anim { opacity: 1; }
    [data-caption] { opacity: 0; }
    [data-caption="4"] { opacity: 1; }
    @media (prefers-reduced-motion: no-preference) {
      .d1 { opacity: 0; animation: cp626hm 8s linear infinite 0s; }
      .c1 { opacity: 0; animation: cp626hmc 8s linear infinite 0s; }
      .d2 { opacity: 0; animation: cp626hm 8s linear infinite 2s; }
      .c2 { opacity: 0; animation: cp626hmc 8s linear infinite 2s; }
      .d3 { opacity: 0; animation: cp626hm 8s linear infinite 4s; }
      .c3 { opacity: 0; animation: cp626hmc 8s linear infinite 4s; }
      .d4 { opacity: 0; animation: cp626hm 8s linear infinite 6s; }
      .c4 { opacity: 0; animation: cp626hmcf 8s linear infinite 6s; }
    }
    @keyframes cp626hm { 0%, 2% { opacity: 0; } 6%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
    @keyframes cp626hmc { 0%, 2% { opacity: 0; } 5%, 22% { opacity: 1; } 26%, 100% { opacity: 0; } }
    @keyframes cp626hmcf { 0%, 2% { opacity: 0; } 5%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
  </style>
  <g class="anim d1" data-etape="1">
    <text x="150" y="26" text-anchor="middle" font-size="13" fill="#334155">1 h, c’est <tspan font-weight="bold">60 min</tspan> : un quart d’heure, c’est</text>
    <text x="150" y="50" text-anchor="middle" font-size="15" font-weight="bold" fill="#b45309">60 ÷ 4 = 15 min</text>
  </g>
  <g class="anim d2" data-etape="2">
    <text x="150" y="80" text-anchor="middle" font-size="14" fill="#334155">9 quarts d’heure : <tspan font-weight="bold" fill="#f97316">9 × 15 = 135 min</tspan></text>
  </g>
  <g class="anim d3" data-etape="3">
    <line x1="34.0" y1="96.0" x2="266.0" y2="96.0" stroke="#334155" stroke-width="1.2"/><polygon points="31.0,96.0 37.0,93.0 37.0,99.0" fill="#334155"/><polygon points="269.0,96.0 263.0,93.0 263.0,99.0" fill="#334155"/>
    <text x="150" y="92" text-anchor="middle" font-size="11" fill="#334155">135 min</text>
    <rect x="30.0" y="104.0" width="106.7" height="30.0" fill="#fed7aa" fill-opacity="0.5" stroke="#b45309" stroke-width="1.8"/>
    <text x="83.3" y="124.0" text-anchor="middle" font-size="14" font-weight="bold" fill="#b45309">60</text>
    <rect x="136.7" y="104.0" width="106.7" height="30.0" fill="#fed7aa" fill-opacity="0.5" stroke="#b45309" stroke-width="1.8"/>
    <text x="190.0" y="124.0" text-anchor="middle" font-size="14" font-weight="bold" fill="#b45309">60</text>
    <rect x="243.3" y="104.0" width="26.7" height="30.0" fill="#f97316" fill-opacity="0.45" stroke="#f97316" stroke-width="1.8"/>
    <text x="256.7" y="124.0" text-anchor="middle" font-size="12" font-weight="bold" fill="#f97316">15</text>
  </g>
  <g class="anim d4" data-etape="4">
    <text x="150" y="160" text-anchor="middle" font-size="16" font-weight="bold" fill="#0f172a"><tspan fill="#b45309">2 h</tspan> <tspan fill="#f97316">15 min</tspan> ✓</text>
  </g>
  <g class="anim c1" data-caption="1">
    <text x="150" y="184" text-anchor="middle" font-size="11.5" fill="#334155">on <tspan font-weight="bold" fill="#b45309">divise 60 par 4</tspan> : un quart d’heure, 15 min</text>
  </g>
  <g class="anim c2" data-caption="2">
    <text x="150" y="184" text-anchor="middle" font-size="11.5" fill="#334155">prends <tspan font-weight="bold" fill="#f97316">9 fois 15 min</tspan> : pose la multiplication !</text>
  </g>
  <g class="anim c3" data-caption="3">
    <text x="150" y="184" text-anchor="middle" font-size="11.5" fill="#334155">découpe 135 en <tspan font-weight="bold" fill="#b45309">paquets de 60</tspan> : 2 paquets, reste 15</text>
  </g>
  <g class="anim c4" data-caption="4">
    <text x="150" y="184" text-anchor="middle" font-size="11.5" fill="#334155">9/4 d’heure, c’est <tspan font-weight="bold">2 h 15 min</tspan> !</text>
  </g>
</svg>`.trim();

const FICHE_HEURES_HM = {
    pages: [
        {
            titre: 'Des minutes, puis des heures',
            lignes: [
                '**Prends ton brouillon.** Une heure, c\'est **60 minutes**.',
            ],
            svg: SVG_HEURES_HM,
        },
    ],
};

// V/F égalités : chaque côté se calcule séparément, puis on compare.
// Exemple hors pool (la combinaison n'est dans aucune ligne du V/F).
const FICHE_EGALITES = {
    pages: [
        {
            titre: 'Calcule chaque côté',
            lignes: [
                'Calcule **chaque côté** de l\'égalité, séparément : ta **calculatrice est autorisée** ici.',
                'Exemple : « la moitié de 30 est égale à 3/5 × 25 » : à gauche 30 ÷ 2 = **15** ; à droite 25 ÷ 5 = 5, puis 3 × 5 = **15**. Mêmes nombres : **vrai** !',
                'Si les deux nombres sont **différents**, l\'égalité est **fausse**.',
            ],
        },
    ],
};

// Bandes : fiche VISUELLE (retour user, pas calculatoire) : 4 × 2/6
// (c = 6 hors POOL_H qui va de 2 à 5) — remplissage À LA SUITE → la
// bande pleine vaut 1 → les 2/6 restants tombent pile sur 1/3 (l’autre
// partage superposé) → 1 + 1/3.
const SVG_BANDES_CP = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 170" width="290" height="165" role="img" data-etapes="4"
     aria-label="4 fois 1 sixième avec une bande. On remplit 4 sixièmes à la suite : 4 fois 1 sixième égale 4 sixièmes. Un autre partage en 3 se superpose : la zone remplie couvre exactement 2 tiers. La même longueur s’écrit 4 sixièmes ou 2 tiers : 2 tiers est la fraction irréductible">
  <style>
    .anim { opacity: 1; }
    [data-caption] { opacity: 0; }
    [data-caption="4"] { opacity: 1; }
    @media (prefers-reduced-motion: no-preference) {
      .d1 { opacity: 0; animation: cp626bd 8s linear infinite 0s; }
      .c1 { opacity: 0; animation: cp626bdc 8s linear infinite 0s; }
      .d2 { opacity: 0; animation: cp626bd 8s linear infinite 2s; }
      .c2 { opacity: 0; animation: cp626bdc 8s linear infinite 2s; }
      .d3 { opacity: 0; animation: cp626bd 8s linear infinite 4s; }
      .c3 { opacity: 0; animation: cp626bdc 8s linear infinite 4s; }
      .d4 { opacity: 0; animation: cp626bd 8s linear infinite 6s; }
      .c4 { opacity: 0; animation: cp626bdcf 8s linear infinite 6s; }
    }
    @keyframes cp626bd { 0%, 2% { opacity: 0; } 6%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
    @keyframes cp626bdc { 0%, 2% { opacity: 0; } 5%, 22% { opacity: 1; } 26%, 100% { opacity: 0; } }
    @keyframes cp626bdcf { 0%, 2% { opacity: 0; } 5%, 95% { opacity: 1; } 98%, 100% { opacity: 0; } }
  </style>
  <rect x="30.0" y="46.0" width="40.0" height="34.0" fill="none" stroke="#334155" stroke-width="1.2" opacity="0.7"/>
  <rect x="70.0" y="46.0" width="40.0" height="34.0" fill="none" stroke="#334155" stroke-width="1.2" opacity="0.7"/>
  <rect x="110.0" y="46.0" width="40.0" height="34.0" fill="none" stroke="#334155" stroke-width="1.2" opacity="0.7"/>
  <rect x="150.0" y="46.0" width="40.0" height="34.0" fill="none" stroke="#334155" stroke-width="1.2" opacity="0.7"/>
  <rect x="190.0" y="46.0" width="40.0" height="34.0" fill="none" stroke="#334155" stroke-width="1.2" opacity="0.7"/>
  <rect x="230.0" y="46.0" width="40.0" height="34.0" fill="none" stroke="#334155" stroke-width="1.2" opacity="0.7"/>
  <g class="anim d1" data-etape="1">
    <rect x="30.0" y="46.0" width="40.0" height="34.0" fill="#3b82f6" fill-opacity="0.7"/>
    <rect x="70.0" y="46.0" width="40.0" height="34.0" fill="#3b82f6" fill-opacity="0.7"/>
    <rect x="110.0" y="46.0" width="40.0" height="34.0" fill="#3b82f6" fill-opacity="0.7"/>
    <rect x="150.0" y="46.0" width="40.0" height="34.0" fill="#3b82f6" fill-opacity="0.7"/>
    <text x="150" y="30" text-anchor="middle" font-size="14" font-weight="bold" fill="#3b82f6">4 × 1/6 = 4/6</text>
  </g>
  <g class="anim d2" data-etape="2">
    <line x1="110.0" y1="40.0" x2="110.0" y2="86.0" stroke="#dc2626" stroke-width="4"/>
    <line x1="190.0" y1="40.0" x2="190.0" y2="86.0" stroke="#dc2626" stroke-width="4"/>
  </g>
  <g class="anim d3" data-etape="3">
    <rect x="30.0" y="46.0" width="160.0" height="34.0" fill="none" stroke="#f97316" stroke-width="3"/>
    <text x="110.0" y="102.0" text-anchor="middle" font-size="14" font-weight="bold" fill="#f97316">= 2/3</text>
  </g>
  <g class="anim d4" data-etape="4">
    <text x="150" y="132" text-anchor="middle" font-size="15" font-weight="bold" fill="#0f172a">4 × 1/6 = <tspan fill="#3b82f6">4/6</tspan> = <tspan fill="#f97316">2/3</tspan> ✓</text>
  </g>
  <g class="anim c1" data-caption="1">
    <text x="150" y="156" text-anchor="middle" font-size="11.5" fill="#334155">remplis <tspan font-weight="bold" fill="#3b82f6">4 sixièmes</tspan> à la suite : 4 × 1/6 = 4/6</text>
  </g>
  <g class="anim c2" data-caption="2">
    <text x="150" y="156" text-anchor="middle" font-size="11.5" fill="#334155">superpose un <tspan font-weight="bold" fill="#dc2626">autre partage</tspan> : en 3</text>
  </g>
  <g class="anim c3" data-caption="3">
    <text x="150" y="156" text-anchor="middle" font-size="11.5" fill="#334155">la <tspan font-weight="bold">même longueur</tspan> couvre pile <tspan font-weight="bold" fill="#f97316">2 tiers</tspan></text>
  </g>
  <g class="anim c4" data-caption="4">
    <text x="150" y="156" text-anchor="middle" font-size="11.5" fill="#334155">4/6 = <tspan font-weight="bold" fill="#f97316">2/3</tspan> : c’est la fraction <tspan font-weight="bold">irréductible</tspan> !</text>
  </g>
</svg>`.trim();

const FICHE_BANDES = {
    pages: [
        {
            titre: 'La même longueur, deux écritures',
            lignes: [
                'Le schéma montre que **4/6, c\'est aussi 2/3** : un autre partage, la même longueur. C\'est la **fraction irréductible** qu\'on te demande parfois !',
            ],
            svg: SVG_BANDES_CP,
        },
    ],
};

const CP_626 = {
    fraction_entier_direct_qcm_unique: FICHE_DE,
    fraction_entier_direct_texte: FICHE_DE,
    fraction_heure_minutes_qcm_unique: FICHE_HEURES_MIN,
    fraction_heure_minutes_texte: FICHE_HEURES_MIN,
    fraction_longueur_segment_qcm_unique: FICHE_DE,
    fraction_longueur_segment_texte: FICHE_DE,
    fraction_diagramme_texte: FICHE_DE,
    fraction_entier_fraction_resultat_qcm_unique: FICHE_FRACTIONNAIRE,
    fraction_entier_fraction_resultat_texte: FICHE_FRACTIONNAIRE,
    multiplication_schema_bandes_qcm_unique: FICHE_BANDES,
    multiplication_schema_bandes_texte: FICHE_BANDES,
    fraction_heure_impropre_hm_texte: FICHE_HEURES_HM,
    egalite_expressions_frac_tableau_vf: FICHE_EGALITES,
};

export default CP_626;
